import React, { useState, useEffect, Suspense } from "react";
import "./App.scss";
import { Container, Spinner } from "react-bootstrap";
import ForgotPage from "./Containers/Login/forgotPage";
import SideBarComp from "./Components/layout/SideBarComp";
import HeaderComp from "./Components/layout/HeaderComp";
import { Route, Switch, useLocation } from "react-router-dom";
import LoginPage from "./Containers/Login/LoginPage";
import SSOAuth from "./Containers/Login/SSOAuth";
import B2CAuth from "./Containers/Login/B2CAuth";

import Error from "./Components/Error/error";
//import Error403Dashboard from "./Components/Error/error403";
import { Chart, registerables } from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import { setAccessToken, setUserDetails, setUserName } from "./redux/redux/global/action";
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router-dom";
import AllSolution from "./Containers/AllSolution/AllSolution";
import AllSolutionApproval from "./Containers/AllSolutionApproval/AllSolutionApproval";
import Reports from "./Containers/Reports/Reports";
import {
  APPROVAL_HIEARCHY_MASTER,
  COMPRESSOR_MASTER,
  COUNTRY_MASTER,
  CUSTOMER_MASTER,
  DEALER_MASTER,
  LOCATION_MASTER,
  MAIL_REMINDER,
  PRODUCT_MASTER,
  ROLE_AUTHORIZATION_MASTER,
  UNIT_CONVERSION_MASTER,
  USER_MASTER,
  CREATE_NEW_SOLUTION,
  DASHBOARD,
  REPORTS,
  ALL_SOLUTION_RECORDS,
  PENDING_FOR_APPROVAL,
} from "./utils/constant";
import Error403Dashboard from "./Components/Error/ErrorDashboard";
import AutoLogOut from "./../src/Components/utility/AutoLogOut";
import Loader from "./Components/utility/Loader";
Chart.register(...registerables);
const Authorization = React.lazy(() => import("./Components/Authorization/Authorization"));
// const SharePointList = React.lazy(() => import("./Components/Masters/SharePointList/SharePointList"));
const Dashboard = React.lazy(() => import("./Containers/Dashboard/Dashboard"));
const LocationMaster = React.lazy(() => import("./Components/Masters/LocationMaster/LocationMaster"));
const RoleMaster = React.lazy(() => import("./Components/Masters/RoleAndAuthorizationMaster/RoleMaster"));
const DealerMaster = React.lazy(() => import("./Components/Masters/DealerMaster/DealerMaster"));
const CustomerMaster = React.lazy(() => import("./Components/Masters/CustomerMaster/CustomerMaster"));
const UserMaster = React.lazy(() => import("./Components/Masters/UserMaster/UserMaster"));
const ProductMaster = React.lazy(() => import("./Components/Masters/ProductMaster/ProductMaster"));
const CountryMaster = React.lazy(() => import("./Components/Masters/CountryMaster/CountryMaster"));
const MailReminder = React.lazy(() => import("./Components/Masters/MailReminder/MailReminder"));
const CompressorMaster = React.lazy(() => import("./Components/Masters/CompressorParameterMaster/CompressorParameterMaster"));
const UnitConversionMaster = React.lazy(() => import("./Components/Masters/UnitConversionMaster/UnitConversionMaster"));
const NewSolution = React.lazy(() => import("./Components/NewSolution/NewSolution"));

function App() {
  const userDetails = useSelector(state => state.global?.userDetails);
  console.log("userDetails",userDetails);
  const access = userDetails?.accessData || [];

  const [menuName, setMenuName] = useState("Dashboard");
  const [showSidebar, setShowSidebar] = useState(false);
  // const [isAuthenticated, setIsAuthenticated] = useState(false);
  //======
  // const isEmployeeAuthenticated = useIsAuthenticated({ instance: msalInstance });
  // const isDealerAuthenticated = useIsAuthenticated({ instance: b2cInstance });
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check for valid authentication token/session
    const token = sessionStorage.getItem('authToken');
    
    if (token && !userDetails) {
      // Token exists but userDetails missing (new tab) - restore from token
      try {
        const decodedToken = jwt_decode(token);
        const storedAccessData = sessionStorage.getItem('accessData');
        if (decodedToken && storedAccessData) {
          const userDetailsWithAccess = {
            ...decodedToken,
            accessData: JSON.parse(storedAccessData)
          };
          dispatch(setUserDetails(userDetailsWithAccess));
          dispatch(setAccessToken(token));
          dispatch(setUserName(decodedToken.um_name));
          setIsAuthenticated(true);
          return;
        }
      } catch (error) {
        console.error('Error restoring user details:', error);
      }
    }
    
    const isValidSession = token && userDetails;
    
    if (isValidSession) {
      setIsAuthenticated(true);
    } else {
      // Force redirect to login for any protected route
      if (location.pathname !== '/' && 
          location.pathname !== '/SSOAuth' && 
          location.pathname !== '/B2CAuth' && 
          !location.pathname.startsWith('/forgotPassword')) {
        history.replace('/');
      }
      setIsAuthenticated(false);
    }
  }, [userDetails, location.pathname, history, dispatch]);

  return (
    <>
      <div>
        {location.pathname !== "/" && <AutoLogOut></AutoLogOut>}
        <Switch>
          <Route
            exact
            path="/"
            render={() => <LoginPage setIsAuthenticated={setIsAuthenticated} />}
          ></Route>
          <Route
            exact
            path="/SSOAuth"
            render={() => <SSOAuth setIsAuthenticated={setIsAuthenticated} />}
          ></Route>
          <Route
            exact
            path="/B2CAuth"
            render={() => <B2CAuth setIsAuthenticated={setIsAuthenticated} />}
          ></Route>
          <Route
            exact
            path="/forgotPassword/:userData?"
            render={() => <ForgotPage />}
          ></Route>
          {/* <Route exact path='/redirect' component={Redirect} /> */}
          {isAuthenticated === true && (
            <Route path="/(.+)" render={() => (
              <Container fluid className="app-layout">
                <SideBarComp
                  showSidebar={showSidebar}
                  setShowSidebar={setShowSidebar}
                  setMenuName={setMenuName}
                  menuName={menuName}
                  userName={userDetails?.um_name}
                  userEmail={userDetails?.um_email}
                />

                <Container bsPrefix="app-container">
                  {showSidebar && (
                    <div
                      onClick={() => setShowSidebar(false)}
                      className="d-md-none d-lg-none blurrOverlay"
                    />
                  )}
                  <div className={showSidebar ? "d-none d-md-block d-lg-block" : ""}>
                    <HeaderComp
                      showSidebar={showSidebar}
                      setShowSidebar={() => setShowSidebar(!showSidebar)}
                      menuName={menuName}
                      setMenuName={setMenuName}
                      userName={userDetails?.um_name}
                      userEmail={userDetails?.um_email}
                    />
                    <div className="main-container">
                      <Switch>
                        
                        <Route exact path="/dashboard">
                          <Suspense fallback={<Loader />}>
                            <Authorization Component={Dashboard} />
                          </Suspense>
                        </Route>
                        {[
                          ["/allsolution", AllSolution, ALL_SOLUTION_RECORDS],
                          ["/loc", LocationMaster, LOCATION_MASTER],
                          ["/role", RoleMaster, ROLE_AUTHORIZATION_MASTER],
                          ["/dealer", DealerMaster, DEALER_MASTER],
                          ["/cust", CustomerMaster, CUSTOMER_MASTER],
                          ["/user", UserMaster, USER_MASTER],
                          ["/allsolutionapproval", AllSolutionApproval, PENDING_FOR_APPROVAL],
                          ["/product", ProductMaster, PRODUCT_MASTER],
                          ["/currency", CountryMaster, COUNTRY_MASTER],
                          ["/mail", MailReminder, MAIL_REMINDER],
                          ["/compressor", CompressorMaster, COMPRESSOR_MASTER],
                          ["/unit", UnitConversionMaster, UNIT_CONVERSION_MASTER],
                          ["/newenquiry", NewSolution, CREATE_NEW_SOLUTION],
                          ["/report", Reports, REPORTS]
                        ].map(([path, Component, permission]) => (
                          <Route key={path} exact path={path}>
                            <Suspense fallback={<Loader />}>
                              <Authorization Component={access.includes(permission) ? Component : Error403Dashboard} />
                            </Suspense>
                          </Route>
                        ))}
                        <Route path="**" render={() => (
                          <Suspense fallback={null}>
                            <Error errorTitle="404 Page Not Found" />
                          </Suspense>
                        )} />
                      </Switch>
                    </div>
                  </div>
                </Container>
              </Container>
            )} />
          )}
        </Switch>
      </div>
      {/* }
    { 
    
    ((validUser==false && isAuthenticated===true) || validDealer ==false || localStorage.getItem('Type')==="") &&
      <LoginPage setValidDealer={setValidDealer} errorMessage={errorMessage}/>} */}
    </>
  );
}

export default App;
 